export default __webpack_public_path__ + "static/media/pic8.06bbc898.jpg";